import { create } from 'zustand'
import { persist } from 'zustand/middleware'

// dev-only harness: lets internal users experience request surfaces the way a
// customer does (see useIsSweetspotTeamMember); never consulted in prod builds
interface DevImpersonationStore {
  viewAsCustomer: boolean
  setViewAsCustomer: (viewAsCustomer: boolean) => void
}

export const useDevImpersonationStore = create<DevImpersonationStore>()(
  persist(
    (set) => ({
      viewAsCustomer: false,
      setViewAsCustomer: (viewAsCustomer: boolean) => set({ viewAsCustomer }),
    }),
    {
      name: 'dev-impersonation',
      partialize: (state) => ({ viewAsCustomer: state.viewAsCustomer }),
    },
  ),
)

const selectViewAsCustomer = (state: DevImpersonationStore) =>
  state.viewAsCustomer

const selectSetViewAsCustomer = (state: DevImpersonationStore) =>
  state.setViewAsCustomer

export const useViewAsCustomer = () =>
  useDevImpersonationStore(selectViewAsCustomer)

export const useSetViewAsCustomer = () =>
  useDevImpersonationStore(selectSetViewAsCustomer)
